"use strict";var o;exports.IFooterIconMargin=void 0,(o=exports.IFooterIconMargin||(exports.IFooterIconMargin={}))[o.LEFT=0]="LEFT",o[o.RIGHT=1]="RIGHT";
//# sourceMappingURL=types.js.map
